import React from "react";
import "./CentralDeAtendimento.css";
import {
  Section,
  Heading,
  Paragraph,
  Button,
  ImageWithDecor,
} from "./UIComponents";

import fotoDestaque from "../../assets/img/central-de-atendimento.webp";

const CentralDeAtendimento: React.FC = () => {
  return (
    <Section className="central-content">
      <ImageWithDecor
        src={fotoDestaque}
        alt="Central de Atendimento - Equipe pronta para ajudar"
      />
      <div className="central-text-area">
        <Heading level={2}>
          Central de
          <br />
          Atendimento
        </Heading>
        <Paragraph>
          Se você é participante da Forluz, acesse agora nossa
          <br />
          Central de Atendimento. É simples, rápida e feita para você!
        </Paragraph>
        <Button
          href="/CentralDeAtendimento/central-atendimento"
          label="Acesse agora"
        />
      </div>
    </Section>
  );
};

export default CentralDeAtendimento;
